import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { HotKeywordsService } from 'src/app/share/service/hot-keywords.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { SECTION_DATA } from 'src/app/web-generator/index-section-generator/service/section-data';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { AbstractIndexSearch } from '../../abstract-index-search';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-index-search-01',
  templateUrl: './index.component.html',
  styleUrls: [
    './index-search-03.component.scss',
  ]
})
export class IndexComponent extends AbstractIndexSearch implements OnInit {
  defaultData = {
    title: '發掘出更多你所不知道的臺灣',
  };

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected http: CommonHttpClientService,
    protected hotKeywordsService: HotKeywordsService,
    protected templateService: TemplateService,
    protected translateService: TranslateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, router, route, http, hotKeywordsService, templateService, translateService);
  }

  ngOnInit(): void {
    this.initData();
    super.ngOnInit();
  }

  /** 初始化區塊資料 */
  protected initData() {
    const defaultDataClone = JSON.parse(JSON.stringify(this.defaultData));
    if (this.section.data) {
      Object.assign(defaultDataClone, this.section.data);
      Object.assign(this.section.data, defaultDataClone);
    } else {
      this.section.data = defaultDataClone;
    }
  }
}
